// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"fdbf3e38","101":"09b1c74d","142":"0ae2c078","221":"6babfca9","328":"d29a7274","388":"bf0c83be","439":"8b512575","453":"a83fb0d0","636":"13ce200d","838":"3efeadc5","859":"99b2c760"}[chunkId] + ".chunk.js";
};